import component from './ar-EG/component';
import globalHeader from './ar-EG/globalHeader';
import marketingCampaigns from './ar-EG/marketingCampaigns';
import menu from './ar-EG/menu';
import pages from './ar-EG/pages';
import pwa from './ar-EG/pwa';
import settingDrawer from './ar-EG/settingDrawer';
import settings from './ar-EG/settings';

export default {
  'navBar.lang': 'اللغات',
  'layout.user.link.help': 'مساعدة',
  'layout.user.link.privacy': 'الخصوصية',
  'layout.user.link.terms': 'الشروط',
  'app.preview.down.block': 'تحميل هذه الصفحة إلى مشروعك',
  'app.welcome.link.fetch-blocks': 'جلب جميع البلوكات',
  'app.welcome.link.block-list': 'بناء صفحات قياسية بسرعة باستخدام البلوكات',
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...marketingCampaigns,
  ...pages,
};
